(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    const footers = document.querySelectorAll('.pt-footer');
    footers.forEach((footer) => {
      const cols = footer.querySelectorAll('[data-pt-fcol]');
      if (!cols.length) return;
      const mq = window.matchMedia('(min-width: 750px)');
      const sync = () => {
        cols.forEach((col) => {
          col.open = mq.matches ? true : col.hasAttribute('data-pt-open-mobile');
        });
      };
      sync();
      mq.addEventListener('change', sync);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
